import { Helmet } from "react-helmet-async"
import { MonthlyTenantReport } from "../../../../../Admin/TenantReports"

export default function MonthlyTenantReportPage() {
	return (
		<>
			<Helmet>
				<title>Monthly Accounts</title>
			</Helmet>
			<MonthlyTenantReport />
		</>
	)
}
